require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('ta-semantic-ui/semantic/dist/components/image.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/table.css');
require('ta-semantic-ui/semantic/dist/components/item.css');
require('ta-semantic-ui/semantic/dist/components/card.css');
require('styles/App.scss');

import React from 'react';
import Masthead from '@ta-interaktiv/react-polymorphic-masthead';
import Tracking from 'ta-react-polymorphic-tracking';
import StandaloneShareButtons from '@ta-interaktiv/react-polymorphic-share-buttons';
import CopyrightNotice from 'ta-react-polymorphic-copyright-notice';
import Waypoint  from 'react-waypoint';
import ArticleTeasers from '@ta-interaktiv/react-article-teasers';



class AppComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state={
      page: "",
      counterClass: "hide"
    }
  }


  render() {
    return (
      <div className='index'>
        <Masthead articleID='11403835' additionalFacebookShares={387} />

        <header className='ui inverted vertical segment reduced-height mobile hidden'
                style={{
                  backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(204,205,210,0.2)), url(${require(
                    './img/cover/schneefeld.jpg')})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover'
                }}>
          <div className='header block'>
            <div className='ui container'>
              <h1 className='ui huge header mobile hidden'>
                Steckengeblieben<br />im Nirgendwo
              </h1>
              <p className='ta lead'>Die Menschen in der Ostukraine sind nach drei Jahren Krieg erschöpft, sie trauern um ihr zerstörtes Leben.  Unser Karikaturist Felix Schaad war vor Ort und hielt die Misere in einem Comic fest.
              </p>
              </div>
          </div>
        </header>


        <header className='ui inverted vertical segment reduced-height mobile only'
                style={{
                  backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(204,205,210,0.2)), url(${require(
                    './img/cover/schneefeld_mobile.jpg')})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover'
                }}>
          <div className='header block'>
            <div className='ui container'>
               <h1 className='ui large header mobile only'>
                 Steckengeblieben<br />im Nirgendwo
              </h1>
              <p className='ta lead'>Die Menschen in der Ostukraine sind nach drei Jahren Krieg erschöpft, sie trauern um ihr zerstörtes Leben.  Unser Karikaturist Felix Schaad war vor Ort und hielt die Misere in einem Comic fest.
              </p>
              </div>
          </div>
        </header>


        <div className='ui vertical infographic segment white-bg'>
          <div className='ui text container'>
            <p className='ta author'>Zeichnungen Felix Schaad</p>

            <Waypoint scrollableAncestor={window} onEnter={(event) => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'startReading'
                  }
                )
              }
            }}/>

            <p className='ta'>
              «Die Vergessenen», titelt TA-Karikaturist Felix Schaad seine Zeichenreportage aus der Ostukraine über die Menschen, die dort zwischen und an den Fronten gefangen sind – vergessen und verraten von den Kriegsherren, ihrer Regierung und der Welt. «Viele sind am Ende ihrer Kräfte», sagt eine Psychologin der Hilfsorganisation Médecins sans Frontières/Ärzte ohne Grenzen (MSF), die Schaad in die Ukraine eingeladen hat. Die Menschen sind nach drei Jahren Krieg erschöpft, sie trauern um ihr zerstörtes Leben, um ihre Häuser, von denen manchen nur Bilder geblieben sind. Die medizinische Versorgung ist faktisch zusammengebrochen, weil auf alles geschossen wird, auch auf Spitäler und Ärzte.
            </p>
             <p className='ta'>
              Es gebe Menschen, die seit zwei Jahren in Kellern schlafen, sagen MSF-Helfer, die in den Orten Kurachowe und Mariupol mobile Kliniken betreiben. Sie verteilen Medikamente, an welche die Patienten sonst nicht herankommen würden und die sie gar nicht bezahlen könnten. Auch psychologische Hilfe wird angeboten, denn viele Menschen leiden an Stress- und Angstsymptomen. Zurückgeblieben im Frontgebiet sind vor allem ältere Frauen und Männer, die nicht das Geld oder nicht die Kraft haben, sich anderswo in der Ukraine eine Wohnung zu mieten und noch einmal ganz von vorne anzufangen. Doch auch Familien sind noch dort. Die MSF-Psychologen betreuen viele traumatisierte Kinder mit Schlafstörungen und Konzentrationsschwäche.
            </p>
              <p className='ta'>
                Die Hoffnung auf den Frieden halte die Menschen aufrecht, berichtet Schaad. Ein unterzeichnetes Friedensabkommen hat das Gebiet schon lange, ebenso ungezählte vereinbarte Waffenruhen – alle wurden gebrochen. Und statt dass es endlich besser wird, nehmen die Kämpfe seit Anfang Jahr wieder zu – und damit die Not der Bevölkerung. Dabei hat nicht nur die Aufmerksamkeit, sondern auch die Hilfe massiv nachgelassen. Für das Jahr 2017 konnte die UNO bisher nur gerade 1,6 Prozent der rund 214 Millionen Franken auftreiben, die benötigt werden für humanitäre Hilfe, auf die in der Ostukraine auf beiden Seiten der Grenze fast vier Millionen Menschen angewiesen sind. Schaad fängt in seiner Zeichenreportage diese Welt der Vergessenen und einen Konflikt ein, der im «Nirgendwo steckengeblieben ist», wie der Karikaturist feststellt.
            </p>
              <p className='author-credit'>Zita Affentranger</p>
          </div>

          <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === 'below') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': '20ContentRead'
              }
            )
          }
        }}/>

        </div>

        <div className='ui vertical segment comics-wrapper'>
          <div className='ui container comic-container'>

              <div className='mobile-only hint'><i className='landscape icon' style={{
                  backgroundImage: `url(${require(
                    './img/landscape_ani.gif')})`,
                  backgroundSize: `40px 40px`
                }}></i>Auf dem Smartphone betrachten Sie die nachfolgenden Zeichnungen am besten im Breitformat.</div>

                   <Waypoint scrollableAncestor={window} onEnter={({ previousPosition, currentPosition, event }) => {
                    this.setState({page: ""});
                    this.setState({counterClass: "hide"});
                  }} />

                   <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                    this.setState({page: "1/14"});
                    this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/01.jpg')} />
                      </div>
                   </Waypoint>


                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                    this.setState({page: "2/14"});
                    this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/02.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "3/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/03.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "4/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/04.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "5/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/05.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "6/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/06.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "7/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/07.jpg')} />
                      </div>
                  </Waypoint>




                  <Waypoint scrollableAncestor={window} onEnter={(event) => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': '50ContentRead'
                      }
                    )
                  }
                }}/>




                <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "8/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/08.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "9/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/09.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "10/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/10.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "11/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/11.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "12/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/12.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "13/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/13.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} bottomOffset='400px' onEnter={({ previousPosition, currentPosition, event }) => {
                      this.setState({page: "14/14"});
                      this.setState({counterClass: "show"});
                  }}>
                      <div className='ui image comic'>
                       <img src={require('./img/hochformat/14.jpg')} />
                      </div>
                  </Waypoint>

                  <Waypoint scrollableAncestor={window} onEnter={({ previousPosition, currentPosition, event }) => {
                    this.setState({page: ""});
                    this.setState({counterClass: "hide"});
                  }} />
          </div>
        </div>

        <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === 'below') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': '75ContentRead'
              }
            )
          }
        }}/>

       <div className='ui vertical infographic segment white-bg'>
          <div className='ui text container'>
            <p className="ta subheading">Making-of</p>
            <p className='ta'>
              Etwas skeptisch seien die Helfer von Médecins sans Frontières in der Ostukraine schon gewesen, was dieser Karikaturist aus der Schweiz denn hier vorhabe. «Doch als sie sich das erste Mal auf den Zeichnungen gesehen haben, war das Eis gebrochen», berichtet Felix Schaad von seiner Reportage. Für den TA-Karikaturisten ist es freilich nicht die erste Reise mit Papier und Stift in ein Krisengebiet. Vor zwei Jahren zeichnete er ebenfalls für Médecins sans Frontières in einem Camp in Sierra Leone einen Comic über Ebola.
            </p>
          </div>
        </div>

        <div className='ui vertical infographic segment white-bg'>
          <div className='ui container'>
            <div className='videoWrapper'>
              <iframe className='externalNNIFrame' src='https://player.newsnetz.tv/player/iframe.php?vid=281718&channel=&adurl=0&language=de&autostart=0&poster=https://server025.newsnetz.tv/281718/frame-36-281718.jpg&video_title=Making Of: Felix Schaads Reise in der Ukraine&video_lead=&site=m&logo=1&flashactive=1&dynamicHeight=1' width='100%' scrolling='no'></iframe>
            </div>
          </div>
        </div>


        <div className='ui vertical infographic segment'>
          <div className='ui text container info-box'>
            <p className="ta subheading">Felix Schaad am Fumetto in Luzern</p>
            <p className='ta'>
              Das Luzerner Comix-Festival Fumetto zeigt Schaads Reportage aus der Ostukraine im Grossformat. Rössligasse 12 (Innenhof), Luzern.<br />Eintritt frei. Bis 9. April.
            </p>
            <p className='ta external-link'>
             <a href='https://www.fumetto.ch/de' target='_blank' ><i className='external icon'/> www.fumetto.ch</a>
             </p>
          </div>
        </div>


         <Waypoint scrollableAncestor={window} onEnter={(event) => {
          if (event.previousPosition === 'below') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'contentBottom'
              }
            )
          }
        }}/>

        <aside className='ui vertical segment'>
          <div className='ui container'>
            <h2 className='ui small infographic dividing header'>Weitere Artikel
                  zum Thema</h2>
                  <br />
            </div>
            <div className='ui container'>
                <ArticleTeasers numberOfCards='three' articleIds={['26241338', '25995829']} style={{maxWidth: '100vw'}}/>
          </div>
        </aside>



        <div className='ui vertical inverted infographic segment'>
          <div className='ui container'>
            <div className='ui stackable two column aligned grid'>
              <div className='column'>
                <table className='ui definition inverted very basic table'>
                  <tbody>
                  <tr>
                    <td>Zeichnungen und Text:</td>
                    <td>Felix Schaad</td>
                  </tr>
                   <tr>
                    <td>Digitales Konzept & Umsetzung:</td>
                    <td>Mathias Lutz und Interaktiv-Team</td>
                  </tr>
                  <tr>
                    <td>Video:</td>
                    <td>Lea Koch</td>
                  </tr>
                  <tr className='desktop-only'>
                    <td colSpan='2'><CopyrightNotice inverted/></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className='column'>

                <table className='ui definition inverted very basic table'>
                  <tbody>
                  <tr>
                    <td><i className='comments icon'/></td>
                    <td>
                      <div className='content'>
                        <div className='header'> Haben Sie Anmerkungen oder
                          einen Fehler entdeckt?
                        </div>
                        <p>
                          <span>Wir freuen uns über Ihre </span>
                          <a href='mailto:interaktiv@tages-anzeiger.ch'>Nachricht</a>
                          <span>.</span>
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan='2' className='footer-sharing'>
                      <div className='spacer'>&nbsp;</div>
                      <StandaloneShareButtons articleID='11403835'/>
                      <Tracking articleId='11403835'/>

                      <Waypoint scrollableAncestor={window}
                                                   onEnter={(event) => {
                                                     if (event.previousPosition ===
                                                       'below') {
                                                       window.dataLayer =
                                                      window.dataLayer || [];
                                                       window.dataLayer.push({
                                                           'event': 'pageBottom'
                                                         }
                                                       )
                                                     }
                                                   }}/>
                      <div className='spacer'>&nbsp;</div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

        {
          //endregion
        }

        <Tracking articleId='11403835'/>

        <div className={this.state.counterClass} >
          <div className='page-count'><i className='clone icon'/> {this.state.page}</div>
        </div>

      </div>
    );
  }
}

AppComponent.defaultProps = {};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/main/Main.js